export const FAQ = [
  { q: 'What is the YourReGen Score?', a: 'Your YourReGen Score is a daily 0–100 number combining Training (40%), Nutrition (40%) and Recovery (20%) compliance over a rolling window. It reflects how consistently you follow your program.' },
  { q: 'How is my Recovery Score calculated?', a: 'Recovery = Sleep (40%) + Fasting (25%) + Meal Timing (15%) + Recovery Activities (20%). Logging extra recovery activities yourself adds a bonus of up to +10 per day.' },
  { q: 'Can I log recovery activities the coach did not assign?', a: 'Yes. On the Recovery tab tap "Log Activity", choose a category and activity (or type your own), set the duration and save. These count as a bonus toward your Recovery Score.' },
  { q: 'How do I log my meals and macros?', a: 'Open Nutrition → search any food, enter the quantity, and macros are calculated automatically. You can also save built meals as templates and favourite them for one-tap logging.' },
  { q: 'Why does my weight differ from what I entered?', a: 'Your weight comes from your onboarding profile and weight logs. Update it any time in Settings → Profile or by logging a new weight under Progress.' },
  { q: 'How do I message my coach?', a: 'Use Settings → Coach Chat (or the Coach tab) for a direct line to Coach JP. You will see a badge when you have unread replies.' },
  { q: 'When does my program unlock?', a: 'After you complete onboarding, Coach JP personalises your plan (usually within 24 hours). You will get a notification when your Training, Nutrition and Recovery pillars unlock.' },
  { q: 'How do referrals work?', a: 'Share your referral code or link from Settings → Referrals. You earn 20% off your next renewal for each friend who joins.' },
];

export const TERMS = `# Terms of Service

_Last updated: June 2026_

Welcome to YourReGen. By creating an account and using this app you agree to these Terms.

## 1. The Service
YourReGen provides personalised coaching content including training, nutrition, recovery and mindset guidance from Coach JP. The content is for general wellness and educational purposes.

## 2. Not Medical Advice
YourReGen is not a medical service. Always consult a qualified healthcare professional before starting any new training, nutrition or fasting protocol, especially if you have a medical condition, are pregnant, or take medication.

## 3. Your Account
You are responsible for keeping your login credentials secure and for all activity under your account. Provide accurate information during onboarding so your program can be tailored correctly.

## 4. Payments & Programs
Program fees, durations and renewal terms are shown at checkout. Access codes and referral discounts are applied as described at the time of redemption.

## 5. Acceptable Use
Do not misuse the app, attempt to access other users' data, or share your account. Coach content is for your personal use only and may not be redistributed.

## 6. Changes
We may update the app and these Terms over time. Continued use after changes means you accept the updated Terms.

## 7. Contact
Questions? Email hello@yourregen.com.`;

export const PRIVACY = `# Privacy Policy

_Last updated: June 2026_

Your trust matters. This policy explains what we collect and why.

## What We Collect
- **Account details**: name, email, phone, country.
- **Health & onboarding data**: age, sex, height, weight, goals, training history, sleep, fasting, recovery logs, progress photos and measurements.
- **Usage data**: workouts, meals and activities you log in the app.

## How We Use It
We use your data solely to deliver and personalise your coaching program, calculate your YourReGen and Recovery scores, and let Coach JP support you. Progress photos are private and visible only to you and your coach.

## Sharing
We do not sell your data. Limited service providers (e.g. secure cloud storage and email delivery) process data on our behalf under confidentiality obligations.

## Your Rights
You can view and edit your profile any time in Settings, and request deletion of your account and data by emailing hello@yourregen.com.

## Security
Passwords are encrypted and data is transmitted over secure connections. No method is 100% secure, but we take reasonable measures to protect your information.

## Contact
Privacy questions? Email hello@yourregen.com.`;

export const NOTIF_OPTIONS = [
  { key: 'meal_reminders', label: '🍽 Nutrition', desc: 'Meal logging & macro reminders' },
  { key: 'workout_reminders', label: '🏋 Training', desc: "Reminders for today's training" },
  { key: 'recovery_reminders', label: '❄ Recovery', desc: 'Sleep, fasting & recovery prompts' },
  { key: 'coach_messages', label: '💬 Coach Messages', desc: 'When Coach JP replies to you' },
  { key: 'achievements', label: '🏆 Achievements', desc: 'Streaks, milestones & score wins' },
  { key: 'weekly_digest', label: '📊 Weekly Reports', desc: 'Your weekly compliance summary' },
];
